import c from "./index95.js";
import i from "./index96.js";
import f from "./index49.js";
const y = (t, o, d = 3) => {
  let r = 0;
  const m = c(50, 250);
  return i((n) => {
    if (!n || typeof n.loaded != "number")
      return;
    const l = n.loaded, e = n.lengthComputable ? n.total : void 0, s = e != null ? Math.min(l, e) : l, u = Math.max(0, s - r), a = m(u);
    r = Math.max(r, s);
    const p = {
      loaded: s,
      total: e,
      progress: e ? s / e : void 0,
      bytes: u,
      rate: a || void 0,
      estimated: a && e ? (e - s) / a : void 0,
      event: n,
      lengthComputable: e != null,
      [o ? "download" : "upload"]: !0
    };
    t(p);
  }, d);
}, v = (t, o) => {
  const d = t != null;
  return [
    (r) => o[0]({
      lengthComputable: d,
      total: t,
      loaded: r
    }),
    o[1]
  ];
}, x = (t) => (...o) => f.asap(() => t(...o));
export {
  x as asyncDecorator,
  v as progressEventDecorator,
  y as progressEventReducer
};
